import { IMAncillaryContent, IMAncillaryContentItem } from '../types'
import { snakeKabobToTitleCase } from '../../../utility'
import {
  createAnchor,
  createUnorderedList,
  wrapB,
  wrapP,
} from '../../html_utility'
import { createNoteNode } from './createNodeWrappers'
import { paragraphWithHeader } from '../../nodeCreationHelpers'

export function ancillaryItemsToString(
  key?: string,
  items?: IMAncillaryContentItem[],
) {
  if (!items?.length) return
  const title = key && snakeKabobToTitleCase(key)
  const listItems = items.map(({ title, description }) => {
    if (!description) return title
    if (description.startsWith('http')) {
      return createAnchor({ link: description, display: title, newTab: true })
    }
    return `${wrapB(title)}${wrapP(description)}`
  })
  const list = createUnorderedList(listItems)
  if (title) {
    return paragraphWithHeader(title, list)
  }
  return wrapP(list)
}

export function requiredPreparation(content: IMAncillaryContent) {
  const contents = Object.entries(content).reduce<string[]>(
    (acc, [key, value]) => {
      switch (key) {
        case 'goals':
        case 'learning_targets':
        case 'materials_to_copy':
        case 'required_materials': {
          const stringVal = ancillaryItemsToString(key, value)
          if (stringVal) acc.push(stringVal)
          return acc
        }
        default:
          if (value.length) {
            console.log(
              `losing this one: ${ancillaryItemsToString(key, value)}`,
            )
          }
          return acc
      }
    },
    [],
  )

  if (!contents.length) return []

  return [
    createNoteNode({
      title: 'Required Preparation',
      studentFacing: false,
      value: contents.join(''),
    }),
  ]
}
